export * from './lib/shared-search-formation.module';
export * from './lib/components/search-formation-resultat/search-formation-resultat.component';
export * from './lib/components/search-page-formation/search-page-Formation.component'
export * from './lib/dircetive/dynamic-component.directive'
export * from './lib/serivce/search-formation.service'
